import { Component, Vue, Prop } from "vue-property-decorator";
import { Form, Button, Input, Select, Modal, Alert } from "ant-design-vue";
import { STATUS } from "@/util/enum";
import InvitationPreview from "@/components/preview/preview.vue";
import { InvitationTemplateService, InvitationService, AccountService } from "@/services";
import { GLGlobal, fmtMsg } from "@/commonui/utils";
import { InvitationHelper } from "@/util/helper";
import { IPreviewModel } from "@/models/content-admin/invitation-preview-model";
import { FormHelper } from "@/commonui/utils/formhelper";
import { ContentAdminLocale } from "@/locales/localeid";

@Component({
	components: {
		Form,
		Alert,
		Item: Form.Item,
		Button,
		Input,
		Select,
		Option: Select.Option,
		Modal,
		InvitationPreview
	}
})
export default class Invitation extends Vue {
	@Prop({ default: false }) visible: boolean | undefined;
	@Prop({ default: null }) unloadInvitation: any;
	@Prop({ default: null }) updateContentAdminList: any;
	public isNotRegistered = false;
	public email = "";
	public userEmail = "";
	public userName = "";
	public InvitationTypeIndex = 14;
	public templateOptions: any = [];
	public status = STATUS.ValidateEmail;
	public isShowPreview = false;
	public invitationForm;
	public previewParams: IPreviewModel = {} as IPreviewModel;
	public loading = false;
	public selectedTemplate = "";

	created() {
		this.invitationForm = this.$form.createForm(this, { name: "invitationForm" });
		this.setInvitationTemplates();
	}

	get StatusValue() {
		return STATUS;
	}

	get formHelper() {
		return FormHelper;
	}

	get contentAdminLocales() {
		return ContentAdminLocale;
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	handleInvitatoinCancel() {
		this.$emit("unloadInvitation");
	}

	validateEmail(e: any) {
		e.preventDefault();
		this.invitationForm.validateFields((err, values) => {
			const isEmailValid = FormHelper.isValidEmail(values.email);
			if (!err && isEmailValid) {
				this.userEmail = values.email;
				this.loading = true;
				AccountService.validateEmail({ email: values.email })
					.then((data: any) => {
						if (data.exist && data.hasConfirmed) {
							this.bindingUser();
						} else {
							this.loading = false;
							this.status = STATUS.InviteNew;
						}
					})
					.catch((error) => {
						this.loading = false;
						console.log(error);
					});
			} else if (!isEmailValid) {
				this.invitationForm.setFields({
					email: {
						value: values.email,
						errors: [new Error(fmtMsg(ContentAdminLocale.InvitationModalEmailInvalid))]
					}
				});
			}
		});
	}

	bindingUser() {
		const params = {
			email: this.userEmail,
			invitationCodeType: this.InvitationTypeIndex,
			referenceId: null
		};

		AccountService.bindingUserByEmail(params)
			.then((data) => {
				this.loading = false;
				this.status = STATUS.ExistedEmail;
				this.triggerListUpdate();
			})
			.catch((error) => {
				this.loading = false;
				console.log(error);
			});
	}

	setInvitationTemplates() {
		const params = {
			isDescending: true,
			detail: true,
			invitationType: this.InvitationTypeIndex,
			regionId: null,
			schoolId: null
		};

		InvitationTemplateService.getTemplateCandidates(params)
			.then((data: any) => {
				this.templateOptions = data.map((template: any) => {
					return {
						Id: template.id,
						Name: template.name
					};
				});

				if (this.templateOptions.length > 0) {
					this.selectedTemplate = this.templateOptions[0].Id;
				}
			})
			.catch((ex) => {
				console.log(ex);
			});
	}

	setPreview() {
		this.invitationForm.validateFields((err, values) => {
			if (!err) {
				this.isShowPreview = true;

				this.previewParams.templateId = values.templateId;
				(this.previewParams.userName = values.name), (this.previewParams.userEmail = this.userEmail);
			}
		});
	}

	back() {
		this.status = STATUS.ValidateEmail;
	}

	handleClose() {
		this.triggerInvitationUnload();
	}

	onSubmit() {
		this.invitationForm.validateFields((err, values) => {
			if (!err && FormHelper.isValidEmail(values.email)) {
				this.loading = true;
				this.userName = values.name;

				InvitationService.generateInvitationCode({
					senderId: GLGlobal.loginInfo().profile.sub,
					invitationType: this.InvitationTypeIndex,
					templateId: values.templateId,
					name: values.name,
					email: this.userEmail
				})
					.then((data: any) => {
						this.loading = false;
						if (!data.sendEmailSuccess) {
							InvitationHelper.sendEmailFail();
						} else {
							this.status = STATUS.ValidateEmail;
							InvitationHelper.sendEmailSuccess();
							this.triggerListUpdate();
							this.triggerInvitationUnload();
						}
					})
					.catch((error) => {
						this.loading = false;
					});
			}
		});
	}

	triggerInvitationUnload() {
		this.$emit("unloadInvitation");
	}

	triggerListUpdate() {
		this.$emit("updateContentAdminList");
	}

	unloadPreview() {
		this.isShowPreview = false;
	}
}
